import React, {useEffect, useState} from 'react';
import { useFetch} from "../../../../components/common/FetchProvider";
import AccountModal from "./AccountModal";
import CommonTable from "./CommonTable";
import {columnsDataAccount} from "../variables/columnsData";
import Loader from "../../../../components/Loader/Loader";

function AccountTable() {
  const fetchWrapper = useFetch();
  const [loading, setLoading] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [error, setError] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [accountData, setAccountData] = useState(null);

  useEffect(() => {
    fetchData();
  }, []);


  const handleLinkClick = () => {
    setShowModal(true);
  };

  const refreshData = () => {
    reload();
  }

  const reload = () => {
    setAccountData(null);
    setApiData([]);
    fetchData();
  };

  const fetchData = async () => {
    setLoading(true);
    try {
      let apiUrl = `${process.env.REACT_APP_API_URL}/v1/configuration/accounts`;

      const userToken = localStorage.getItem("token");
      const response = await fetchWrapper(apiUrl, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${userToken}`,
        },
      });
      setLoading(false);
      if (response.ok) {
        const responseData = await response.json();
        if (responseData.data && responseData.data.length > 0) {
          setApiData(responseData.data);
        } else {
          setError(true);
        }
      } else {
        setError(true);
        console.error('Error fetching API data:', response.status);
      }
    } catch (error) {
      setLoading(false);
      setError(true);
      console.error('Error fetching API data:', error);
    }
  };

  const mappedApiData = apiData.map((item) => ({
    id: item.id,
    accountName: item.accountName,
    accountNumber: item.accountNumber,
    accountCurrency: item.accountCurrency,
    accountType: item.accountType,
    receiveFees: item.receiveFees ? "Yes" : "No",
    initialBalance: item.initialBalance,
    action: "Action"
  }));

  const handleActionClick = (rowData) => {
    let data = apiData.find((item) => item.id === rowData.id);
    setAccountData(data);
    handleLinkClick();
  };

  return (
      <div className="10">
        <Loader show={loading}/>
        <header className="relative flex items-center justify-between">
          <div className="text-xl font-bold text-navy-700 dark:text-white">
            Contas
          </div>
          {/* Links with Separator */}
          <div className="flex justify-center items-center font-bold text-brand-600">
            <div>
              <button onClick={handleLinkClick}>Cadastrar</button>
              {/* Conditional rendering of modal */}
              {showModal && (
                  <AccountModal
                      showModal={showModal}
                      setModalState={setShowModal}
                      refreshData={refreshData}
                      accountData={accountData}
                      setAccountData={setAccountData}
                  />
              )}
            </div>

          </div>

        </header>

        <div className="mt-1">
          {loading ? (
              <div></div>
          ) : apiData && apiData.length > 0 ? (
              <CommonTable
                  columnsData={columnsDataAccount}
                  tableData={mappedApiData}
                  onActionClick={handleActionClick}
              />
          ) : (
              <></>
          )}
        </div>
      </div>
  );
}

export default AccountTable;
